import { useIntl, IntlShape } from 'react-intl';

import { getLocalizedColorName } from '@/i18n/getLocalizedColorName';
import type { TMake } from '@src-common/api/definitions/w4d-cars-types';
import type { SelectFieldItem } from '@src-common/view/adapters/SelectField';

import { useModelConfig } from './useModelConfig';

const getLocalizedColorOptions = (selectOptions: SelectFieldItem[], intl: IntlShape) =>
  selectOptions.map(({ value }) => ({
    title: getLocalizedColorName(value, intl),
    value,
  }));

const useColors = (make?: TMake, model?: string) => {
  const intl = useIntl();
  const modelConfig = useModelConfig(make, model);

  if (!modelConfig || !model) {
    return [];
  }

  return getLocalizedColorOptions(modelConfig.color, intl);
};

const useInteriorColors = (make?: TMake, model?: string) => {
  const intl = useIntl();
  const modelConfig = useModelConfig(make, model);

  if (!modelConfig || !model) {
    return [];
  }

  return getLocalizedColorOptions(modelConfig.interiorColor, intl);
};

export { useColors, useInteriorColors };
